import { Directive, OnChanges, Input, SimpleChanges } from "@angular/core";
import { NG_VALIDATORS, AbstractControl, ValidationErrors } from "@angular/forms";
import { BaseValidator } from "@tcm-modules/tcm-core.module";


@Directive({
  selector: '[regExpValidator]',
  standalone: false,
  providers: [
    { provide: NG_VALIDATORS, useExisting: RegexpValidator, multi: true }
  ]
})
export class RegexpValidator extends BaseValidator implements OnChanges {
  @Input('regExpValidator') regexp: string;
  @Input('regExpError') regExpError: string;  

  constructor() {
    super('regExpValidator');
  }

  ngOnChanges(changes: SimpleChanges): void {    
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    if (this._onChange) this._onChange();
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors | null { 
    if (control.value == null || control.value == "" || this.regexp == null)
      return null;

    let valid: boolean = (new RegExp(this.regexp)).test(control.value)

    if (valid) 
      return null;

    let validationResult = { 'regExpValidator': { error: null } };

    if (this.regExpError) {
      validationResult.regExpValidator.error = this.regExpError;
    }

    return validationResult;
  }

}
